import { render, staticRenderFns } from "./ComponentSettingsBtn.vue?vue&type=template&id=e767de36&scoped=true"
import script from "./ComponentSettingsBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentSettingsBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentSettingsBtn.vue?vue&type=style&index=0&id=e767de36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e767de36",
  null
  
)

export default component.exports